export default __webpack_public_path__ + "static/media/Rubik-MediumItalic.4f1c9690.ttf";